import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Faq extends Page{
    constructor(){
        super({
            id : 'faq',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}